import type { FC, ReactElement } from 'react';

import type { AssetsAssetSchemaTypedWithId } from '@iconik-io/iconik-api/src/services/assets';

import { selectIsEmailAuthorizationNeeded } from '../../ducks/share/selectors';
import Icon, { ICONS } from '../../icons/icon';
import { useAppSelector } from '../../store/react_redux_typed';
import Button from '../../ui/button/button';
import type { SegmentFormType } from '../segment_form/types';

import styles from '../segment_form/segment_form.module.css';

type Props = {
  asset: AssetsAssetSchemaTypedWithId;
  canEditTags?: boolean;
  onEnsureAuthorization?: () => void;
  onFormTypeButtonClick?: (tab: SegmentFormType) => void;
  formType?: SegmentFormType;
};

export const AssetSegmentFormControlsTop: FC<Props> = ({
  onEnsureAuthorization,
}) => {
  const shareLinkUserEmail = useAppSelector(
    (state) => state.share.shareLinkUserEmail,
  );
  const isEmailAuthorizationNeeded = useAppSelector(
    selectIsEmailAuthorizationNeeded,
  );

  const elements: ReactElement[] = [];

  if (isEmailAuthorizationNeeded) {
    elements.push(
      <div key="share_authorize" className={styles.authorize}>
        {shareLinkUserEmail ? (
          <div className={styles.authorized_email}>
            <Icon icon={ICONS.User} />
            <span className={styles.authorized_email_value}>
              {shareLinkUserEmail}
            </span>
          </div>
        ) : (
          <Button
            className={styles.identify_button}
            icon={ICONS.User}
            noBorder
            onClick={onEnsureAuthorization}
            type="button"
          >
            Identify to comment
          </Button>
        )}
      </div>,
    );
  }

  if (elements.length === 0) {
    return null;
  }

  return (
    <div className={styles.top_block} data-ui="segment-tabs">
      {elements}
    </div>
  );
};
